import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 8;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'je-page',
      title: `Journal Entry Hub <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'This is where you create manual journal entries and view all transactions. Journal entries are the backbone of double-entry accounting.',
      attachTo: { element: '[data-tour="je-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-date-memo',
      title: `Date & Memo <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Set the transaction date and add a memo describing the entry. The memo appears in reports and helps identify transactions later.',
      attachTo: { element: '[data-tour="je-date-memo"]', on: 'bottom' },
      beforeShowPromise() {
        // Expand the collapsible entry form so the tour can highlight it
        window.dispatchEvent(new Event("tour:expand-entry-form"));
        // Wait for the MUI Collapse animation to finish
        return new Promise((resolve) => setTimeout(resolve, 400));
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-lines',
      title: `Debit & Credit Lines <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Each journal entry has multiple lines. Enter the account, fund, and amount for each line. <strong>Debits increase asset/expense accounts, credits increase liability/income/equity accounts.</strong> Total debits must equal total credits.',
      attachTo: { element: '[data-tour="je-lines"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-fund-balance',
      title: `Fund Balance Check <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: "This shows the running balance for each fund in your entry. If a fund's debits don't equal its credits, you'll see a warning — but the entry can still be recorded as long as total debits equal total credits.",
      attachTo: { element: '[data-tour="je-fund-balance"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-record-btn',
      title: `Record Entry <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Once your entry balances, click here to save it. The transaction syncs to BigQuery instantly and appears in all reports in real time.',
      attachTo: { element: '[data-tour="je-record-btn"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-table',
      title: `Transaction Table <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'All your transactions appear here. Click any row to inspect, edit, or delete it. Split transactions show a summary row — click to expand and see all lines.',
      attachTo: { element: '[data-tour="je-table"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-expand-splits',
      title: `Expand & Collapse <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: "Toggle 'Expand All Splits' to see every line of every transaction at once. When collapsed, multi-line transactions show a summary with the total amount. <strong>Collapsed rows automatically sum the individual lines to show totals.</strong>",
      attachTo: { element: '[data-tour="je-expand-splits"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'je-filter-btn',
      title: `Filters <span class="t3-shepherd-step-count">${stepCounter(8)}</span>`,
      text: 'Open the filter panel to narrow transactions by account, fund, contact, label, date range, or amount. Use the AND/OR toggle to control whether transactions must match all filters or just one.',
      attachTo: { element: '[data-tour="je-filter-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'journalEntry',
  pathPattern: '/upkeep/journal-entry',
  getSteps,
  label: 'Journal Entry Tour',
});
